<template>
  <div class="unm__outer the-intro intro__stage">
    <div class="unm__container">
      <div class="intro__container">
        <h2 class="heading-main">
          <strong>At UNM,</strong>
        </h2>
        <!-- eslint-disable-next-line max-len -->
        <p class="paragraph paragraph-splash">Learn to expect the unexpected. Over four years in our Land of Enchantment, you’ll discover a college experience one mile above every other university around.</p>
        <svg class="intro__breaker glyph__breaker">
          <use xlink:href="/images/graphics/menu-anchor-glyph.svg#menu-anchor-glyph" />
        </svg>
        <button
          class="action-button action-button__turquoise cta-large"
          @click="startQuiz">
          <span class="action-button__dummy action-button__transparent cta-large">
            <div class="action-button__shadow"/>
          </span>
          Take the Quiz
        </button>
      </div>
    </div>
    <TheParallax/>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';
  import TheParallax from '@/components/TheParallax';

  export default {
    name: 'TheIntro',
    components: {
      TheParallax,
    },
    created() {
      this.setTitle('Intro');
    },
    methods: mapMutations(['setTitle', 'startQuiz']),
  };
</script>

<style lang="scss">
.intro {
    position: relative;
}

.intro__overlay {
    background-color: $turquoise;
}

.intro__container {
    @include flex-grid-column(12);
    text-align: center;

    @include breakpoint(medium) {
        @include flex-grid-column(8);
        @include grid-column-offset(2);
    }
}

.intro__breaker {
    margin-top: 40px;
    margin-bottom: 40px;
}

.the-intro {
  &.v-enter,
  &.v-leave-to {
    opacity: 0;
  }

  &.v-enter-active,
  &.v-leave-active {
    transition-duration: $stage-transition-duration;
    transition-property: opacity;
    transition-timing-function: $transition-timing-function;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheIntro.vue